var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.243,
    height: 36.364,
    viewBox: "0 0 32.243 36.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.042,
    y1: 0.208,
    x2: 0.897,
    y2: 0.754,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dcef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#29abe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#0c7dc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#626366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#a8abad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#d8d9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#dadcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#c6c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#abadaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#8a8b8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#626365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(-24 -38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LC-02",
    transform: "translate(24 38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M184.191,168.7l-9.1-5.25L166,168.7l.171,4.161a11.1,11.1,0,0,0,3.035,7.286c1.707,1.707,4.235,3.261,5.89,3.261s4.184-1.555,5.89-3.261a11.1,11.1,0,0,0,3.035-7.286Zm-4.306,10.192c-1.388,1.388-3.444,2.652-4.79,2.652s-3.4-1.264-4.79-2.652a9.026,9.026,0,0,1-2.468-5.925l-.139-3.384,7.4-4.269,7.4,4.269-.139,3.384A9.023,9.023,0,0,1,179.885,178.892Z",
    transform: "translate(-158.973 -154.931)",
    fill: "#1f4175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M113.613,72.079V88.764L99.12,97.2v-5.14l10.041-5.869V74.49ZM96,92.063,85.822,86.194V74.5l-4.452-2.41V88.764L96,97.2Zm-9.3-19.85,10.794-6.232,10.785,6.289,4.452-2.571L97.491,60.84l-15.246,8.8Z",
    transform: "translate(-81.37 -60.84)",
    fill: "#1f4175"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(8.725 10.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M189.066,199.478a9.026,9.026,0,0,1-2.468-5.925l-.139-3.384,7.4-4.269,7.4,4.269-.139,3.384a9.026,9.026,0,0,1-2.468,5.925c-1.388,1.388-3.444,2.652-4.79,2.652S190.454,200.867,189.066,199.478Z",
    transform: "translate(-186.46 -185.9)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M198.14,245.858l6.365-4.338-7.072,3.114-7.072-3.114,6.365,4.338.707,7.275Z",
    transform: "translate(-181.311 -226.519)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6434fe67688033432076827fd765b741.svg";
export { ForwardRef as ReactComponent };